module.exports = __webpack_public_path__ + "static/media/uniswap.55b9a73f.svg";